<div
  class="tiime-icon-container"
  tiimeTooltip
  [tooltipPosition]="tooltipPosition"
  [tooltipContent]="commentTooltipTemplate"
  data-cy="comment-cell"
>
  <mat-icon fontSet="fontastic" fontIcon="icon-user-comment-fontastic"></mat-icon>
</div>
<ng-template #commentTooltipTemplate>
  {{ comment }}
</ng-template>
